/** PosHub API uses uppercase weekday names (e.g. MONDAY, TUESDAY) */
export const POSHUB_WEEKDAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];
